module.exports = __webpack_public_path__ + "media/images/cms/img_slide_18-a42b04174d35066408f008a19c3129ea.jpg";